"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var bing_layer_component_1 = require("../components/map/bing-layer.component");
var react_1 = require("react");
var useCoordinates = function () {
    var _a = react_1.useState({
        loading: false,
    }), status = _a[0], setStatus = _a[1];
    var fetchCoordinates = react_1.useCallback(function (address) {
        var path = "https://dev.virtualearth.net/REST/v1/Locations?countryRegion=" + (address === null || address === void 0 ? void 0 : address.countryCode) + "&postalCode=" + (address === null || address === void 0 ? void 0 : address.postalCode) + "&locality=" + (address === null || address === void 0 ? void 0 : address.city) + "&addressLine=" + (address === null || address === void 0 ? void 0 : address.street) + "&maxRes=1&key=" + bing_layer_component_1.bingKey;
        setStatus({ loading: true });
        fetch(path)
            .then(function (response) { return response.json(); })
            .then(function (response) {
            var coordinates = response.resourceSets[0].resources[0].point.coordinates;
            setStatus({ loading: false, coordinates: { latitude: coordinates[0], longitude: coordinates[1] } });
        })
            .catch(function (error) {
            setStatus({ loading: false, error: error });
        });
    }, []);
    return __assign(__assign({}, status), { fetchCoordinates: fetchCoordinates });
};
exports.default = useCoordinates;
//# sourceMappingURL=use-coordinates.hook.js.map